import React from 'react'

const LeftArrowIcon = (props) =>(
	<svg id="arrow-animation" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12">
	  <path id="down-arrow" d="M11.9,7.794a.775.775,0,0,1-.682.421H6.787v8.944a.789.789,0,1,1-1.574,0V8.215H.78A.775.775,0,0,1,.1,7.794c-.131-.252-.131.411,0,.159L5.318.421a.763.763,0,0,1,1.364,0L11.9,7.953C12.033,8.206,12.033,7.542,11.9,7.794ZM6,2.5,2.144,7.533H9.83Z" transform="translate(0 12) rotate(-90)" fill={props.fill}/>
	</svg>

)

export default LeftArrowIcon